import React, { useState } from "react";
import MockTestCircle from "./mocktestcircle";
import { useStores } from "../../store";
import { useObserver } from "mobx-react";
import { useNavigate } from "react-router-dom";

export default function MockTest(props) {
  const { MockStore, LabelStore, UserStore, CommonStore } = useStores();
  const labels = Array.isArray(MockStore?.applicants)
    ? MockStore.applicants.map((label) => label._id)
    : [];
  console.log("this is labels", labels);
  const url = window.location.href;
  const [ApplicationProgressData, setApplicantionProgressData] = useState();
  const navigate = useNavigate();
  // Create a URL object and retrieve the 'mocktestId' from the query parameters
  const urlObj = new URL(url);
  const mocktestId = urlObj.searchParams.get("id");
  // console.log("hello this is mocktestId ", mocktestId);
  // const [lastInterview, setLastInterview] = useState(null);
  // const [applicationId, setApplicationId] = useState(null);

  // useEffect(() => {
  //   UserStore.GetApplicationProgress("", "", mocktestId).then(() => {
  //     if(UserStore.ApplicationDetails){
  //       console.log("this is Application  Details", toJS(UserStore.ApplicationDetails));
  //     if(UserStore.ApplicationDetails?.mockTestStatus === "pending" || UserStore.ApplicationDetails?.mockTestStatus === "completed"){
  //       CommonStore.ApplicationProgress[1].hidden = false;
  //       if(UserStore.ApplicationDetails?.mockTestStatus === "pending"){
  //         CommonStore.ApplicationProgress[1].completed = false;
  //       }
  //       else{
  //         CommonStore.ApplicationProgress[1].completed = true
  //       }
  //     }
  //     else{
  //       CommonStore.ApplicationProgress[1].hidden = true;
  //     }
  //     if(UserStore.ApplicationDetails?.technicalInterviewStatus === "pending" || UserStore.ApplicationDetails?.technicalInterviewStatus === "completed"){
  //       CommonStore.ApplicationProgress[2].hidden = false;
  //       if(UserStore.ApplicationDetails?.technicalInterviewStatus === "pending"){
  //         CommonStore.ApplicationProgress[2].completed = false;
  //       }
  //       else{
  //         CommonStore.ApplicationProgress[2].completed = true
  //       }
  //     }
  //     else{
  //       CommonStore.ApplicationProgress[2].hidden = true;
  //     }
  //     if(UserStore.ApplicationDetails?.hrInterviewStatus === "pending" || UserStore.ApplicationDetails?.hrInterviewStatus === "completed"){
  //       CommonStore.ApplicationProgress[3].hidden = false;
  //       if(UserStore.ApplicationDetails?.hrInterviewStatus === "pending"){
  //         CommonStore.ApplicationProgress[3].completed = false;
  //       }
  //       else{
  //         CommonStore.ApplicationProgress[3].completed = true
  //       }
  //     }
  //     else{
  //       console.log("UserStore.ApplicationDetails?.hrInterviewStatus",UserStore.ApplicationDetails?.hrInterviewStatus);
  //       CommonStore.ApplicationProgress[3].hidden = true;
  //     }
  //     if(UserStore.ApplicationDetails?.shortlisted === true){
  //       CommonStore.ApplicationProgress[4].completed = true;
  //     }
  //     else{
  //       CommonStore.ApplicationProgress[4].completed = false;
  //     }
  //     if(UserStore.ApplicationDetails?.hired === true){
  //       CommonStore.ApplicationProgress[5].hired = true;
  //     }
  //     else{
  //       CommonStore.ApplicationProgress[5].hired = false;
  //     }
  //     if(UserStore.ApplicationDetails?.rejected === true){
  //       CommonStore.ApplicationProgress[4].rejected = true;
  //     }
  //     else{
  //       CommonStore.ApplicationProgress[4].rejected = false;
  //     }
  //     setApplicationId(UserStore.ApplicationDetails?.applicationId);
  //     const getNextStepId = (details) => {
  //       if (details.mockTestStatus !== "completed" && details.mockTestStatus !== null) return details.mockTestId;
  //       if ((details.mockTestStatus === "completed" || details.mockTestStatus === null) &&
  //           details.technicalInterviewStatus !== "completed" && details.technicalInterviewStatus !== null) return details.technicalId;
  //       if ((details.technicalInterviewStatus === "completed" || details.technicalInterviewStatus === null) &&
  //           details.hrInterviewStatus !== "completed" && details.hrInterviewStatus !== null) return details.hrId;
  //       return null; // All interviews completed, or null treated as completed
  //   };
  //   const nextStepId = getNextStepId(UserStore.ApplicationDetails);
  //   setLastInterview(nextStepId);
  //     }

  //   })
  // }, [])

  const cutOffRaw = MockStore.invitation?.cutOff;
  const cutOffPercent =
    cutOffRaw != null && cutOffRaw !== ""
      ? parseFloat(String(cutOffRaw).replace("%", ""))
      : null;
  const accuracy = MockStore.report?.categoryWiseReport?.overall?.accuracy ?? 0;
  const passedCutOff =
    cutOffPercent !== null &&
    !isNaN(cutOffPercent) &&
    accuracy >= cutOffPercent;

  return useObserver(() => (
    <div className="mt-5">
      {/* {
        UserStore.ApplicationDetails &&
        <div className="w-full ml-0 bg-white md:top-0 lg:top-0 py-2 left-10 top-0 z-50 shadow-xl justify-between items-center rounded-lg w-full  md:px-[2%] lg:px-[2%] px-10 flex p-0">
        <div className="w-fit -ml-6 md:overflow-x-hidden lg:overflow-x-hidden md:overflow-x-hidden lg:overflow-x-hidden  overflow-x-scroll no-scrollbar ">
          <ApplicationProgress className="w-fit" />
        </div>
        {lastInterview ? <>
          <button onClick={() => {
          console.log("this is lastInterview and applicationid", lastInterview, applicationId);
          if(lastInterview){
            navigate(`/interview-invitation?meetingid=${lastInterview}&applicationId=${applicationId}`);
          }
        }} className="bg-primary text-white h-fit md:text-base lg:text-base text-lg font-semibold w-fit px-5 py-1 md:hidden lg:hidden rounded-lg">
          Continue
        </button>
        <button onClick={() => {
          console.log("this is lastInterview and applicationid", lastInterview, applicationId);
          if(lastInterview){
            navigate(`/interview-invitation?meetingid=${lastInterview}&applicationId=${applicationId}`);
          }
        }} className="bg-primary text-white h-fit md:text-base lg:text-base text-xs font-semibold w-fit md:px-7 lg:px-7 py-3 md:flex lg:flex hidden rounded-xl">
          Continue with Next step
        </button>
        </> : <>
        <p className="bg-green-500 text-white h-fit md:text-xs lg:text-sm text-xs font-semibold w-fit md:px-7 lg:px-7 py-3 md:flex lg:flex hidden rounded-xl"> Application Submitted Succesfully</p>
        <p className="bg-green-500 text-white h-fit md:text-base lg:text-base text-[10px] truncate font-semibold w-fit px-5 py-1 md:hidden lg:hidden rounded-lg"> Submitted Succesfully</p>
        </>}
      </div>
      } */}
      <div className="flex items-center gap-5">
        <h1 style={{ fontSize: "2rem", color: "#FF6B00" }}>
          {props?.branch} Mock Test Report
        </h1>
        {/* {JSON.parse(localStorage.getItem("user"))?.role?.role === "company" && (
          <div>
            {labels[0] ? (
              <MdBookmark
                onClick={() => {
                  console.log(labels);
                  LabelStore.setCurrentSection("redirect");
                  console.log(LabelStore.currentSection);
                  LabelStore.setApplicantLabelArray(labels);
                  LabelStore.setsection("mockTest");
                  LabelStore.setApplicantId(MockStore?.report?._id);
                  LabelStore.setApplicant_id_mock(mocktestId);
                  LabelStore.setApplicants(true);
                }}
                className="text-2xl text-primary"
              />
            ) : (
              <MdBookmark
                onClick={() => {
                  console.log(labels);
                  LabelStore.setCurrentSection("redirect");
                  console.log(LabelStore.currentSection);
                  LabelStore.setApplicantLabelArray(labels);
                  LabelStore.setsection("mockTest");
                  LabelStore.setApplicantId(mocktestId);
                  LabelStore.setApplicant_id_mock(MockStore?.report?._id);
                  LabelStore.setApplicants(true);
                }}
                className="text-2xl text-gray-300"
              />
            )}
          </div>
        )} */}
      </div>

      <div className="flex" style={{ width: "100%" }}>
        <MockTestCircle
          number={MockStore.report?.categoryWiseReport?.overall?.total ?? 0}
          title="No. of questions"
        />
        <MockTestCircle
          number={MockStore.report?.categoryWiseReport?.overall?.correct ?? 0}
          title="Correct answers"
        />
        <MockTestCircle
          number={MockStore.report?.categoryWiseReport?.overall?.incorrect ?? 0}
          title="wrong answers"
        />
        <MockTestCircle
          number={
            MockStore.report?.categoryWiseReport?.overall?.accuracy
              ? MockStore.report?.categoryWiseReport?.overall?.accuracy?.toFixed(
                  0,
                ) + "%"
              : "0"
          }
          title="overall percentage"
        />
      </div>

      {cutOffPercent !== null && !isNaN(cutOffPercent) && (
        <div className="flex flex-wrap items-center gap-4 mt-5 p-4 rounded-xl border border-gray-200 bg-gray-50 w-fit">
          <div className="flex items-center gap-2">
            <span className="text-gray-500 font-medium">Cutoff:</span>
            <span className="font-bold text-gray-800">{cutOffPercent}%</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-gray-500 font-medium">Score:</span>
            <span className="font-bold text-gray-800">
              {accuracy.toFixed(0)}%
            </span>
          </div>
          <span
            className={`px-4 py-1 rounded-full text-sm font-semibold text-white ${
              passedCutOff ? "bg-green-500" : "bg-red-500"
            }`}
          >
            {passedCutOff ? "Shortlisted" : "Not Shortlisted"}
          </span>
        </div>
      )}
    </div>
  ));
}
